/**
 * Handle mobile mega menu sliding panels
 */
const initMobileMegaMenu = () => {
    if (window.innerWidth >= 992) {
        return;
    }

    // Handle mobile menu link clicks
    const mobileMenuLinks = document.querySelectorAll('.js-mega-menu-mobile-link');

    for (const link of mobileMenuLinks) {
        link.addEventListener('click', event => {
            event.preventDefault();

            // Get data attributes
            const targetId = link.getAttribute('data-target');
            const targetLevel = document.getElementById(targetId);

            if (!targetLevel) {
                return;
            }

            // Get parent level
            const currentLevelEl = link.closest('.exp-benchmark-tool-mega-menu__level');
            if (!currentLevelEl) {
                return;
            }

            // Ensure target level is displayed before animating
            targetLevel.style.display = '';

            // Animate transition to next level
            currentLevelEl.classList.remove('is-active');
            currentLevelEl.classList.add('is-previous');
            targetLevel.classList.add('is-active');
        });
    }

    // Handle back button clicks
    const backButtons = document.querySelectorAll('.exp-benchmark-tool-mega-menu__back-button');

    for (const button of backButtons) {
        button.addEventListener('click', () => {
            // Get the current panel
            const currentLevel = button.closest('.exp-benchmark-tool-mega-menu__level');
            if (!currentLevel) {
                return;
            }

            // Get data attributes
            const returnToLevel = button.getAttribute('data-return-to');
            const returnToId = button.getAttribute('data-return-id');

            // Find target level to return to
            let targetLevel;

            if (returnToLevel === '1') {
                // Main level
                targetLevel = document.querySelector('.exp-benchmark-tool-mega-menu__level[data-level="1"]');
            } else if (returnToLevel === '2' && returnToId) {
                // Second level with specific parent ID
                targetLevel = document.getElementById(`level-2-${returnToId}`);
            }

            if (!targetLevel) {
                return;
            }

            // Ensure target level is displayed before animating
            targetLevel.style.display = '';

            // Animate transition back
            currentLevel.classList.remove('is-active');
            targetLevel.classList.remove('is-previous');
            targetLevel.classList.add('is-active');
        });
    }

    // Add transition end listeners to handle display:none after transition
    const mobileMenuLevels = document.querySelectorAll('.exp-benchmark-tool-mega-menu__level');
    mobileMenuLevels.forEach(level => {
        level.addEventListener('transitionend', event => {
            // Only handle transform transitions
            if (event.propertyName === 'transform') {
                // If this is a previous level that has completed its transition
                if (level.classList.contains('is-previous')) {
                    // Hide it completely after transition
                    level.style.display = 'none';
                }

                // When returning to a previous level, make sure it's displayed
                if (level.classList.contains('is-active')) {
                    level.style.display = '';

                    // Find any previously hidden levels and make them visible again
                    document.querySelectorAll('.exp-benchmark-tool-mega-menu__level.is-previous').forEach(prevLevel => {
                        if (prevLevel !== level) {
                            prevLevel.classList.remove('is-previous');
                            prevLevel.style.display = 'none';
                        }
                    });
                }
            }
        });
    });
};

/**
 * Handle desktop mega menu functionality
 */
const initDesktopMegaMenu = () => {
    if (window.innerWidth < 992) {
        return;
    }

    // First level menu items
    const menuMain = document.querySelectorAll('.js-mega-menu');
    for (const menuItem of menuMain) {
        menuItem.addEventListener('click', event => {
            event.preventDefault();

            // Reset expanded states
            const expandedItems = document.querySelectorAll('.js-mega-menu-link[aria-expanded="true"]');
            for (const item of expandedItems) {
                item.setAttribute('aria-expanded', 'false');
            }

            // Hide all submenu elements
            const elementsToHide = [
                document.querySelectorAll('.js-mega-menu-children-sec'),
                document.querySelectorAll('.js-mega-menu-children-sec .js-mega-menu-list'),
                document.querySelectorAll('.js-mega-menu-children-third'),
                document.querySelectorAll('.js-mega-menu-children-third .js-mega-menu-list'),
            ];

            for (const elements of elementsToHide) {
                for (const element of elements) {
                    element.style.display = 'none';
                }
            }
        });
    }

    // Second level items (first column items)
    const firstLevelItems = document.querySelectorAll('.js-mega-menu-children .has-children .js-mega-menu-link');
    for (const item of firstLevelItems) {
        item.addEventListener('click', event => {
            event.preventDefault();

            // Reset expanded states
            const expandedItems = [
                document.querySelectorAll('.js-mega-menu-children .js-mega-menu-link[aria-expanded="true"]'),
                document.querySelectorAll('.js-mega-menu-children-sec .js-mega-menu-link[aria-expanded="true"]'),
            ];

            for (const group of expandedItems) {
                for (const el of group) {
                    el.setAttribute('aria-expanded', 'false');
                }
            }

            // Set current item as expanded
            item.setAttribute('aria-expanded', 'true');

            // Hide all submenu elements
            const elementsToHide = [
                document.querySelectorAll('.js-mega-menu-children-sec'),
                document.querySelectorAll('.js-mega-menu-children-sec .js-mega-menu-list'),
                document.querySelectorAll('.js-mega-menu-children-third'),
                document.querySelectorAll('.js-mega-menu-children-third .js-mega-menu-list'),
            ];

            for (const elements of elementsToHide) {
                for (const element of elements) {
                    element.style.display = 'none';
                }
            }

            // Show target submenu
            const menuId = item.getAttribute('id');
            const targetMenu = document.querySelector(`.js-mega-menu-children-sec #${menuId}`);

            if (targetMenu) {
                targetMenu.style.display = 'grid';
                targetMenu.parentNode.style.display = 'block';
            }
        });
    }

    // Third level items (second column items)
    const secondLevelItems = document.querySelectorAll('.js-mega-menu-children-sec .has-children .js-mega-menu-link');
    for (const item of secondLevelItems) {
        item.addEventListener('click', event => {
            event.preventDefault();

            // Reset expanded states
            const expandedItems = [
                document.querySelectorAll('.js-mega-menu-children-sec .js-mega-menu-link[aria-expanded="true"]'),
                document.querySelectorAll('.js-mega-menu-children-third .js-mega-menu-link[aria-expanded="true"]'),
            ];

            for (const group of expandedItems) {
                for (const el of group) {
                    el.setAttribute('aria-expanded', 'false');
                }
            }

            // Set current item as expanded
            item.setAttribute('aria-expanded', 'true');

            // Hide third level menus
            const thirdLevelMenus = document.querySelectorAll('.js-mega-menu-children-third .js-mega-menu-list');
            for (const menu of thirdLevelMenus) {
                menu.style.display = 'none';
            }

            // Show target submenu
            const menuId = item.getAttribute('id');
            const targetMenu = document.querySelector(`.js-mega-menu-children-third #${menuId}`);

            if (targetMenu) {
                targetMenu.style.display = 'grid';
                targetMenu.parentNode.style.display = 'block';
            }
        });
    }

    // Add mask effect
    const megaMenuMask = () => {
        const bodyElement = document.querySelector('body');
        const contentWrapper = document.querySelector('#content');
        const megaMenuItems = document.querySelectorAll('.js-mega-menu');

        if (!bodyElement || !contentWrapper || !megaMenuItems.length) {
            return;
        }

        for (const item of megaMenuItems) {
            item.addEventListener('show.bs.dropdown', () => {
                bodyElement.classList.add('overflow-hidden');
                contentWrapper.classList.add('content-wrapper--mask');
            });

            item.addEventListener('hide.bs.dropdown', () => {
                bodyElement.classList.remove('overflow-hidden');
                contentWrapper.classList.remove('content-wrapper--mask');
            });
        }
    };

    megaMenuMask();
};

/**
 * Prevent closing mega menu on clicks inside it
 */
const preventClosingMegaMenu = () => {
    const menuItems = document.querySelectorAll('.js-mega-menu-dropdown');
    for (const item of menuItems) {
        item.addEventListener('click', event => {
            event.stopPropagation();
        });
    }
};

/**
 * Initialize the appropriate menu based on screen size
 */
const initMegaMenu = () => {
    if (window.innerWidth < 992) {
        initMobileMegaMenu();
    } else {
        initDesktopMegaMenu();
    }

    preventClosingMegaMenu();
};

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
    initMegaMenu();
});

// Handle window resize
let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        const wasMobile = window.innerWidth < 992;
        const isMobileNow = window.innerWidth < 992;

        // Only reinitialize if breakpoint changed
        if (wasMobile !== isMobileNow) {
            // Since we've completely restructured the menu, just reload the page
            window.location.reload();
        }
    }, 250);
});
